module.exports = __webpack_public_path__ + "images/xero.png";


//////////////////
// WEBPACK FOOTER
// ./images/xero.png
// module id = 1134
// module chunks = 1